export const convertToTreeData = (flatData) => {
  if (!flatData) return [];

  if (flatData.children) {
    return flatData.children.map((child) => ({
      name: child.name,
      value: child.id,
      children: child.children ? convertToTreeData(child) : [],
    }));
  }

  const itemMap = {};
  flatData.forEach((item) => {
    itemMap[item.id] = {
      name: item.name,
      value: item.id,
      children: [],
    };
  });

  const treeData = [];

  flatData.forEach((item) => {
    if (item.parent_id !== null && itemMap[item.parent_id]) {
      itemMap[item.parent_id].children.push(itemMap[item.id]);
    } else {
      treeData.push(itemMap[item.id]);
    }
  });

  return treeData;
};

export const convertToCodeTreeData = (flatData) => {
  if (!Array.isArray(flatData)) return [];

  const itemMap = {};
  flatData.forEach((item) => {
    itemMap[item.id] = {
      name: item.name,
      value: item.code || `category_${item.id}`,
      disabled: !item.code,
      children: [],
    };
  });

  const treeData = [];
  flatData.forEach((item) => {
    if (item.parent_id !== null && itemMap[item.parent_id]) {
      itemMap[item.parent_id].children.push(itemMap[item.id]);
    } else {
      treeData.push(itemMap[item.id]);
    }
  });

  const pruned = (nodes) =>
    nodes
      .map((node) => ({ ...node, children: pruned(node.children) }))
      .filter((node) => !node.disabled || node.children.length);

  return pruned(treeData);
};

export const withSelectableParents = (treeData) => {
  if (!treeData || !Array.isArray(treeData)) return [];

  const modifyParentNodes = (node) => {
    if (node.children && node.children.length > 0) {
      const parentAsChild = {
        name: `${node.name}`,
        value: node.value,
        id: node.id,
        isParentCopy: true,
      };

      node.value = `00_${node.value}`;
      node.children.unshift(parentAsChild);

      for (let i = 1; i < node.children.length; i += 1) {
        modifyParentNodes(node.children[i]);
      }
    }

    return node;
  };

  return treeData.map(modifyParentNodes);
};

export const categoryIdsFromTree = (values) =>
  (values || []).map((value) =>
    typeof value === "string" && value.startsWith("00_")
      ? parseInt(value.substring(3), 10)
      : value
  );
